// @flow

/*::
declare var __webpack_require__: mixed;
*/
module.exports = typeof __webpack_require__ !== "undefined";